import React from 'react';
import CabCrudPage from './CabCrudPage';

const AdminCabsSeatConfigurations = () => (
  <CabCrudPage
    title="Seat Configurations"
    description="Define seating capacity and layout rules."
    resource="seat-configurations"
    defaultItem={{
      name: '',
      seatCapacity: 4,
      luggageCapacity: '',
      isActive: true,
    }}
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'seatCapacity', label: 'Seats' },
      { key: 'luggageCapacity', label: 'Luggage' },
    ]}
    fields={[
      { name: 'name', label: 'Name', required: true },
      { name: 'seatCapacity', label: 'Seat capacity', type: 'number', required: true },
      { name: 'luggageCapacity', label: 'Luggage capacity', type: 'number' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
  />
);

export default AdminCabsSeatConfigurations;
